/**
 * @param payload
 * @author Aladdin Al-awadat (a.alawadat@elevatus.io)
 * @returns {function(*): void}
 * @description update permissions handler
 */
import {PermissionsStates} from "../../States";

export function updatePermissions(payload) {
  if (!payload) return null;
  localStorage.setItem("permissionsReducer", JSON.stringify(payload));

  return {
    type: PermissionsStates.SUCCESS,
    payload,
  };
}
export function deletePermissions() {
  return {
    type: PermissionsStates.DELETE,
  };
}
